/* unplugin-vue-components disabled */import script from "./GoTop.vue?vue&type=script&setup=true&lang=js"
export * from "./GoTop.vue?vue&type=script&setup=true&lang=js"

import "./GoTop.vue?vue&type=style&index=0&id=4b3ed9a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3ed9a2"]])

export default __exports__